export default {
  home: 'Startseite',

  // Smart search
  'smart-search.suggestions': 'Vorschläge',
  'smart-search.facilities': 'Einrichtungen durchsuchen',
  'smart-search.prev-facilities': 'Von Ihnen besuchte Einrichtungen',
  'smart-search.suggestion.my-appointments': 'Meine Termine',
  'smart-search.suggestion.my-documents': 'Meine Dokumente',
  'smart-search.suggestion.new-appointment': 'Termin buchen',

  // Partners
  'our-partners': 'Kunden und Partner',
  'our-partners.description': 'Wir kooperieren eng mit unseren Kunden & Partnern.',

  'home.info.1': 'Medizinische Termine revolutioniert',
  'home.info.1.tag': 'Ablauf',
  'home.info.1.subtitle': 'Einfach. Sicher. Schnell.',
  'home.info.1.text':
    'Mit dem {tenant} Patientenportal werden Sie sowohl vor, während als auch nach Ihrem Besuch in der Klinik durchgängig begleitet. Ihre Termine können Sie bequem von zu Hause buchen und verwalten. Wählen Sie dafür die gewünschte Sprechstunde aus und vereinbaren Sie Ihren Wunschtermin.',

  'home.info.2': 'Terminbuchung',
  'home.info.2.subtitle': 'Jetzt online Termin vereinbaren',
  'home.info.2.text': 'Terminbuchung',
  'home.info.2.option-1.title': 'Einrichtung auswählen',
  'home.info.2.option-1.sub-title': 'Wählen Sie eine Einrichtung aus.',

  'home.info.2.option-2.title': 'Datum und Uhrzeit auswählen',
  'home.info.2.option-2.sub-title': 'Wählen Sie den gewünschten Zeitslot aus.',

  'home.info.2.option-3.title': 'E-Mail Bestätigung',
  'home.info.2.option-3.sub-title':
    'Sie erhalten nach erfolgreicher Buchung von uns eine Bestätigungs-E-Mail, die Sie bei der Vorstellung in der ausgewählten Einrichtung vorzeigen können.',

  'home.info.3': 'Verwaltung Ihrer Dokumente',
  'home.info.3.tag': 'Dokumente',
  'home.info.3.subtitle': 'Dokumente online verwalten',
  'home.info.3.text':
    'Mit {tenant} Medical können Sie für die Behandlung relevante Dokumente vorab für Ihre Ärztin oder Ihren Arzt freigeben. Nach Ihrer Behandlung stehen Ihnen hier auch etwaige Befunde und weitere freigegebene Dokumente zum Download zur Verfügung.',
  'home.info.3.option-1.title': 'Dateien hochladen',
  'home.info.3.option-1.sub-title': 'Über das Upload-Symbol können Sie Dateien hochladen.',

  'home.info.3.option-2.title': 'Dateien einsehen',
  'home.info.3.option-2.sub-title':
    'Im Reiter Dateien können Sie alle von Ihnen hochgeladenen Dateien einsehen und verwalten. Hier können Sie auch Befunde und weitere von medizinischem Personal freigegebene Dokumente einsehen.',

  'home.info.4': 'Zwei-Faktor-Authentifizierung',
  'home.info.4.tag': 'Sicherheit',
  'home.info.4.subtitle': 'Doppelter Schutz für Ihr {tenant} Medical Konto.',
  'home.info.4.text':
    'Um Ihr Konto noch besser vor potenziellen Angreifern zu schützen, verwenden wir eine Zwei-Faktor-Authentifizierung.',
  'home.info.4.option-1.title': 'Login',
  'home.info.4.option-1.sub-title': 'Loggen Sie sich mit Ihren Zugangsdaten ein.',

  'home.info.4.option-2.title': 'E-Mail Code',
  'home.info.4.option-2.sub-title':
    'Ist der letzte Login einige Zeit her, werden Sie nach der Anmeldung auf eine Zwei-Faktor-Authentifizierung (2FA) Seite weitergeleitet. Sie werden von uns eine E-Mail bekommen mit der Sie die Anmeldung bestätigen können.',

  'home.info.4.option-3.title': 'PIN Eingabe',
  'home.info.4.option-3.sub-title':
    'Geben Sie den PIN aus der E-Mail in das PIN-Feld ein, um die Anmeldung zu bestätigen.',

  'home.app': 'Smartphone App',
  'home.app.subtile': 'Heute noch herunterladen und Vorteile entdecken',
  'home.app.text':
    'Unsere App gibt es kostenlos im App Store und im Google Play Store ab sofort zum Download',

  'home-qa.title': 'Haben Sie Fragen?',
  'home-qa.subtitle': 'Antworten auf die meist gestellten Fragen',

  'home.qa.1.question': 'Sind meine Daten sicher?',
  'home.qa.1.answer':
    'Ihre Daten sind durch den Einsatz hochmoderner Verschlüsselungstechnologien geschützt. Dadurch bleiben Ihre Daten vertraulich und stehen nur Ihnen und Ihrem ärztlichen Fachpersonal zur Verfügung.',
  'home.qa.2.question': 'Ich kann meinen Termin nicht wahrnehmen. Was kann ich tun? (Stornierung)',
  'home.qa.2.answer':
    'Falls Sie Ihren Termin nicht wahrnehmen können, können Sie diesen in der Terminübersicht stornieren.',
  'home.qa.2.reschedule': 'Termin stornieren',
  'home.qa.3.question':
    'Muss ich etwas bezahlen, um das {tenant} Patientenportal benutzen zu können?',
  'home.qa.3.answer':
    'Nein, das {tenant} Patientenportal ist für Patient*Innen dauerhaft kostenfrei nutzbar.',
  'home.qa.4.question': 'Was gibt es nach der Buchung meines Termins zu beachten?',
  'home.qa.4.answer':
    'Nach der Buchung Ihres Termins erhalten Sie eine Bestätigungs-E-Mail mit einem QR-Code, den Sie bei der Vorstellung in der ausgwählten Partnerklinik vorzeigen können. Dieser beinhaltet keinerlei personenbezogene Daten und dient ausschließlich zur Identifizierung Ihres Termins.',
  'home.qa.4.content':
    'Je nach Auswahl des Termintyps ist es möglich, dass Sie zur Bearbeitung von Aufgaben (Fragebögen, Dateifreigabe, etc.) aufgefordert werden. Informationen hierzu können Sie in der jeweiligen Terminübersicht einsehen.',
  'home.qa.5.question': 'Ich habe keine Terminbestätigungs-E-Mail erhalten',
  'home.qa.5.answer':
    'Falls Sie keine Bestätigung für Ihren Termin erhalten haben, können Sie jederzeit den QR-Code in der Terminübersicht öffnen.',
  'home.qa.5.content': 'Meine Termine',

  'home.appointment': 'Online Terminbuchung',
  'home.unverified-user': 'Sie haben Ihren Account noch nicht verifiziert.',
  'home.unverified-user.description':
    'Bitte verifizieren Sie Ihr Konto um Terminanfragen stellen zu können. Öffnen Sie dazu einfach den Link den wir Ihnen in der Bestätigungsmail an die E-Mail-Adresse {email} geschickt haben.',
  'home.unverified-user.verify': 'Kontoverwaltung',

  'home.hello': 'Hallo, {name}',
  'home.find-your-appointment': 'Finden Sie Ihren Termin',
  'home.documents': 'Ihre Dokumente',
  'home.appointment.meta':
    'Mit {tenant} ist es so einfach wie noch nie, online einen Termin zu buchen.',
  'home.create-appointment': 'Termin vereinbaren',
  'home.see-documents': 'Dokumente einsehen',
  'home.documents.meta':
    'Hier können Sie Ihre medizinischen Dokumente und Befunde einsehen. Wir garantieren für Ihre Datensicherheit.',

  'home.data-security': 'Datensicherheit',
  'home.data-security.meta':
    'Ihre Daten sind durch den Einsatz hochmoderner Verschlüsselungstechnologien geschützt.',
  'home.data-security.more': 'Mehr erfahren',

  'home.portal-user-invite.title': 'Konto verknüpfen',
  'home.portal-user-invite.description':
    'Geben Sie bitte Ihr Geburtsdatum ein um Ihre Identität zu verifizieren und die Verknüpfung mit der Klinik abzuschließen.',
  'home.portal-user-invite.decline': 'Ablehnen',
  'home.portal-user-invite.verify-and-link': 'Verifizieren und Verknüpfen',
  'home.portal-user-invite.account-linked': 'Account verknüpft',
  'home.portal-user-invite.linkage-failed': 'Verknüpfung fehlgeschlagen',
  'home.portal-user-invite.cancelled-or-invalid':
    'Die Verknüpfung ist ungültig oder abgelaufen. Bitte wenden Sie sich an die Klinik.',
  'home.portal-user-invite.date-of-birth': 'Geburtsdatum',
  'home.portal-user-invite.wrong-dob': 'Falsches Geburtsdatum. {tries} Versuche verbleibend',
};
